import Sidebar from '../../containers/SideBar'
import { ListaProjetos } from './styles'

const ListaDeProjetos = () => (
  <>
    <Sidebar />
    <ListaProjetos />
  </>
)

export default ListaDeProjetos
